// controlApi.js
import { createApi} from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const controlApi = createApi({
  reducerPath: "controlApi",
  baseQuery,
  tagTypes: ["ControlDetails"],
  endpoints: (builder) => ({

    getControlDetailsById: builder.query({
      query: ({id}) => `/export/product/controlDetails/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];

        // Ensure it's always an array
        const normalized = Array.isArray(data) ? data : [data];

        // Add `id` field from exportEntityId
        return normalized.map((item) => ({
          ...item,
          id: item.controlDetailsId, // 👈 use backend's exportEntityId
        }));
      },
      providesTags: ["ControlDetails"],
    }),

    createControlDetail: builder.mutation({
      query: ({id, ...data}) => ({
        url: `/export/product/controlDetails/${id}`,
        method: "PUT", 
        body: { ControlDetails:data },
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ControlDetails"],
    }),

    updateControlDetail: builder.mutation({
      query: ({ id,subId , ...data  }) => ({
        url: `/export/product/controlDetails/${id}/${subId}`,
        method: "PUT",
        body: { ControlDetails:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["ControlDetails"],
    }),

    deleteControlDetail: builder.mutation({
      query: ({id}) => ({
        url: `/export/product/controlDetails/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["Quota"],
    }),
  }),
});

export const {
  useLazyGetControlDetailsByIdQuery,
  useCreateControlDetailMutation,
  useUpdateControlDetailMutation,
  useDeleteControlDetailMutation,
} = controlApi;
